import React, { useContext } from 'react';
import { Typography, Paper, Box } from '@mui/material';
import { GlobalContext } from '../context/Provider';
import { getDecryptedDataFromSessionStorage } from '../utils';
import { SECRET_KEY } from '../constants/encriptKey';

export const DebugSidebar = () => {
  const { roleUser } = useContext(GlobalContext);
  const decryptedData = getDecryptedDataFromSessionStorage(SECRET_KEY);
    
  // 🚨 DEBUG COMPONENT - Cambiar a true para mostrar
  const showDebug = false;
  
  if (!showDebug) {
    return null;
  }
  
  return (
    <Paper 
      sx={{ 
        position: 'fixed', 
        top: 100, 
        right: 20, 
        p: 2, 
        zIndex: 9999,
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        maxWidth: 400
      }}
    >
      <Typography variant="h6" color="primary">
        🔍 Debug Sidebar Status
      </Typography>
      <Typography variant="body2">
        <strong>Role User:</strong> {JSON.stringify(roleUser)}
      </Typography>
      <Typography variant="body2">
        <strong>Role Type:</strong> {typeof roleUser}
      </Typography>
      <Typography variant="body2">
        <strong>Role ID:</strong> {roleUser?.id || 'N/A'}
      </Typography>
      <Typography variant="body2">
        <strong>Role Name:</strong> {roleUser?.name || 'N/A'}
      </Typography>
      <Typography variant="body2">
        <strong>Role String:</strong> {String(roleUser)}
      </Typography>
      <Typography variant="body2">
        <strong>Role Object Keys:</strong> {roleUser ? Object.keys(roleUser).join(', ') : 'None'}
      </Typography>
      <Typography variant="body2">
        <strong>Is Admin (role.id === 1):</strong> {roleUser?.id === 1 ? 'Yes' : 'No'}
      </Typography>
      <Typography variant="body2">
        <strong>Old validation (Number(roleUser) === 1):</strong> {Number(roleUser) === 1 ? 'Yes' : 'No'}
      </Typography>
      <Typography variant="body2">
        <strong>Session Storage:</strong> {sessionStorage.getItem('encryptedData') ? 'Present' : 'Missing'}
      </Typography>
      
      {decryptedData && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="body2">
            <strong>Decrypted Data:</strong> {JSON.stringify(decryptedData, null, 2)}
          </Typography>
          <Typography variant="body2">
            <strong>User ID:</strong> {decryptedData.id || 'N/A'}
          </Typography>
          <Typography variant="body2">
            <strong>User Name:</strong> {decryptedData.nombre || 'N/A'}
          </Typography>
          <Typography variant="body2">
            <strong>User Email:</strong> {decryptedData.email || 'N/A'}
          </Typography>
          <Typography variant="body2">
            <strong>Access Token:</strong> {decryptedData.accessToken ? 'Present' : 'Not Present'}
          </Typography>
        </Box>
      )}
      
      {!decryptedData && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" color="error">
            <strong>Decrypted Data:</strong> NULL/UNDEFINED
          </Typography>
        </Box>
      )}
    </Paper>
  );
};
